class MCProductGrid extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      collectionToggler: '[data-collection-toggler]',
      collection: '[data-collection]'
    }

    this.classes = {
      active: 'active',
      hidden: 'hidden'
    }
    
    this.data = {
      collectionHandle: 'collectionHandle',
      section: 'section'
    }

    this.collectionTogglers = this.querySelectorAll(this.selectors.collectionToggler);
    this.collections = this.querySelectorAll(this.selectors.collection);

    this.collectionTogglers.forEach(ct => ct.addEventListener('click', this.onTogglerClick));
    
  }

  collectionChangeUnsubscriber = undefined;

  connectedCallback() {
    if (!this.collections.length) return;
    
    this.collectionChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.collectionChange, (event) => {
      if (event.data.sectionId == this.dataset[this.data.section]) return;
      const collectionHandle = event.data.collectionHandle;
      this.changeCollection(collectionHandle);
    });
  }

  disconnectedCallback() {
    if (this.collectionChangeUnsubscriber) {
      this.collectionChangeUnsubscriber.unsubscribe();
    }
  }

  onTogglerClick = (e) => {
    const toggler = e.currentTarget;
    const collectionHandle = toggler.dataset[this.data.collectionHandle];
    const sectionId = this.dataset[this.data.section];

    this.changeCollection(collectionHandle);

    publish(PUB_SUB_EVENTS.collectionChange, {
      data: {
        sectionId: sectionId,
        collectionHandle: collectionHandle
      }
    });
  }
  
  changeCollection(collectionHandle) {
    this.collectionTogglers.forEach(ct => {
      ct.classList.toggle(this.classes.active, ct.dataset[this.data.collectionHandle] == collectionHandle);
    });
    
    this.collections.forEach(c => {
      c.classList.toggle(this.classes.hidden, c.dataset[this.data.collectionHandle] != collectionHandle);
    });
  }
  
}

customElements.define('mc-product-grid', MCProductGrid);